import { Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A7FIAIssuersEdit } from "./edit";
import { A7FIAIssuersTable } from "./table";

export default function A7FIAIssuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | FIA Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A7FIAIssuersEdit />} />
      <Route index element={<A7FIAIssuersTable />} />
    </Routes>
  );
}
